/* istanbul ignore file */

// tslint:disable-next-line:only-arrow-functions
(function(w, d, s, g, js, fjs) {
  // @ts-ignore
  g = w.gapi || (w.gapi = {});
  // @ts-ignore
  g.analytics = {
    q: [],
    ready(cb: any) {
      this.q.push(cb);
    },
  };
  // @ts-ignore
  js = d.createElement(s);
  // @ts-ignore
  fjs = d.getElementsByTagName(s)[0];
  // @ts-ignore
  js.src = 'https://apis.google.com/js/platform.js';
  // @ts-ignore
  fjs.parentNode.insertBefore(js, fjs);
  // @ts-ignore
  js.onload = () => {
    // @ts-ignore
    g.load('analytics');
  };
})(window, document, 'script');
